import React from 'react';
import styles from '../ScoreRules/ScoreRules.module.css';

const CompetitionSystemsDescription = () => {
    return (
        <div className={styles.scoreRulesContainer}>
            <h1>Systemy rozgrywek w turniejach BTT</h1>

            <div className={styles.scoreRulesText}>

                <h5>1. <i>Każdy z każdym</i></h5>
                <p className={styles.competitionDescription}>W tym systemie każdy uczestnik gra z każdym innym
                    uczestnikiem turnieju. Kolejność meczów jest ustalana według metody Bergera parowania rywali w
                    systemie kołowym.</p>
                <p className={styles.competitionDescription}>Klasyfikacja w tabeli jest określana według
                    następuących
                    kryteriów:</p>
                <li>Liczba wygranych setów,</li>
                <li>Liczba, będąca różnicą pomiędzy gemami wygranymi i przegranymi. Punkty tiebreaka trzeciego seta
                    przeliczane są proporcjonalnie do liczby gemów w secie,
                    np. jeżeli pierwsze dwa sety toczą się do 4 wygranych gemów, to 10 pkt tiebreka przeliczana jest na
                    4 pkt. ,
                </li>
                <li>W przypadku, gdy dwóch graczy posiada równą liczby punktów oraz ten sam wynik, będący różnicą gemów
                    wygranych i przegranych,
                    decyduje bezpośredni wynik meczu pomiędzy tymi graczami.
                </li>

                <h5>2. <i>System pucharowy</i></h5>
                <p className={styles.competitionDescription}>Uczestnicy są eliminowani po każdej przegranej.
                    Turniej trwa, dopóki nie pozostanie jeden zwycięzca. Ponieważ w BTT przyjęliśmy zasadę rozegrania
                    przynamniej dwóch meczów w turnieju, to system ten używany jest głównie jako druga część systemu
                    'Faza grupowa + faza finałowa'.</p>

                <h5>3. <i>Brazylijski do dwóch przegranych</i></h5>
                <p className={styles.competitionDescription}>Podobny do systemu pucharowego,
                    z tą różnicą, że po pierwszej przegranej gracze otrzymują drugą szansę na wygranie nawet całego
                    turnieju. Po drugiej porażce
                    zawodnik kończy swój udział w zawodach.
                </p>

                <h5>4. <i>Faza grupowa + faza finałowa</i></h5>
                <p className={styles.competitionDescription}>
                    Turniej rozpoczyna się fazą grupową, w której uczestnicy grają w grupach każdy z każdym.
                    Dwóch najlepszych z każdej grupy awansuje do fazy finałowej, gdzie grają w systemie pucharowym.
                </p>

                <br/>
                <br/>

                <h5><i>Ilość meczów w zależności od liczby graczy</i></h5>
                <p className={styles.competitionDescription}>
                    Poniższa tabela prezentuje ilość meczów, które należy rozegrać w turnieju dla wybranego systemu rozgrywek.
                    Druga liczba wskazuje na minimalną ilość meczów, którą zawodnik winien zagrać aby osiągnąć mecz finałowy.
                </p>

                <div className={styles.imageContainer}>
                </div>
                <div className={styles.tableWrapper}>
                    <table className={styles.systemsTable}>
                        <thead>
                        <tr>
                            <th>Liczba <br/>graczy</th>
                            <th>Każdy z <br/>każdym</th>
                            <th>Pucharowy</th>
                            <th>Brazylijski</th>
                            <th>Grupa+<br/>finał</th>
                            <th>Liczba <br/>grup</th>
                        </tr>
                        </thead>
                        <tbody>
                        {[
                            [4, '6\n3', '4\n2', '-', '-', '-'],
                            [5, '10\n4', '5\n2', '-', '-', '-'],
                            [6, '15\n5', '6\n2', '10\n3', '10\n4', 2],
                            [7, '21\n6', '7\n2', '12\n3', '13\n4', 2],
                            [8, '28\n7', '8\n3', '14\n4', '16\n5', 2],
                            [9, '36\n8', '9\n3', '16\n4', '15\n4', 3],
                            [10, '45\n9', '10\n3', '18\n4', '18\n4', 3],
                            [11, '55\n10', '11\n3', '20\n4', '21\n4', 3],
                            [12, '66\n11', '12\n3', '22\n4', '20\n5', 4],
                            [13, '78\n12', '13\n3', '24\n4', '23\n5', 4],
                            [14, '91\n13', '14\n3', '26\n5', '26\n5', 4],
                            [15, '105\n14', '15\n3', '28\n5', '29\n5', 4],
                            [16, '120\n15', '16\n4', '30\n5', '32\n6', 4]
                        ].map((row, idx) => (
                            <tr key={idx}>
                                {row.map((cell, i) => (
                                    <td key={i}>
                                        {typeof cell === 'string' ? (
                                            cell.split('\n').map((line, index) => (
                                                <div key={index}>{line}</div>
                                            ))
                                        ) : cell}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    <p className={styles.tableNote}>
                        <strong>Legenda:</strong><br/>
                        Pierwsza liczba – łączna liczba meczów<br/>
                        Druga liczba – najkrótsza droga do finału
                    </p>
                </div>


            </div>
        </div>
    );
};

export default CompetitionSystemsDescription;
